import React from 'react'

function TodoAppHome() {
  return (
  
<div className="p-6 bg-gray-100 rounded-lg shadow-md">
      <h1 className="text-2xl font-bold text-gray-800 mb-4">
        Full-Stack CRUD Todo App
      </h1>
      <p className="text-gray-700 mb-4">
        I developed a feature-rich Todo app with a <span className="font-semibold">PocketBase</span> backend and a{' '}
        <span className="font-semibold">Next.js</span> frontend. This project enabled me to master several critical aspects of full-stack development:
      </p>
      <h2 className="text-xl font-semibold text-gray-800 mb-2">Key Learnings</h2>
      <ul className="list-disc pl-6 text-gray-700 mb-4">
        <li>
          <span className="font-semibold">API Integration:</span> Connecting the backend and frontend seamlessly for efficient communication and data exchange.
        </li>
        <li>
          <span className="font-semibold">Data Flow Management:</span> Implementing robust mechanisms to handle and synchronise data between the server and client.
        </li>
        <li>
          <span className="font-semibold">Authentication:</span> Securing the application by managing user authentication and access control.
        </li>
        <li>
          <span className="font-semibold">CRUD Operations:</span> Building and optimising Create, Read, Update, and Delete functionalities across the full stack.
        </li>
      </ul>
      <p className="text-gray-700">
        This project refined my ability to design, implement, and deploy a full-stack application, focusing on performance, scalability, and
        user experience. It was a valuable opportunity to enhance my skills in building modern, production-ready web applications.
      </p>
    </div>

)
}

export default TodoAppHome